<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import Icon from "@components/common/Icon.svelte";
	import { iconMap } from "@core/assets/icons/iconMap.js";
	import type { ContentType } from "@core/schema/ContentType.js";
	import type { ContentBlockComponentProps } from "./ContentBlockComponentProps.js";

	const { data }: ContentBlockComponentProps<ContentType.Benefits> = $props();
</script>

<div
	class={[
		"grid md:grid-cols-2 lg:grid-cols-3 w-fit mx-auto gap-2 items-stretch",
		data.benefits.length > 6 && "xl:grid-cols-4",
	]}
>
	{#each data.benefits as benefit (benefit)}
		{@const icon = iconMap[benefit.icon]}
		<article
			class="bg-white w-full max-w-[22.5rem] min-h-[12.25rem] md:min-h-[17.25rem] h-full rounded-3xl p-4 gap-5 md:gap-6 lg:gap-8 flex flex-col"
		>
			{#if icon}
				<Icon {icon} class="size-10 md:size-12 text-cmcprimary" />
			{/if}
			<div class="flex flex-col gap-2">
				<h3 class="text-sm md:!text-base/[1.4] text-black !m-0 !tracking-[0] font-bold">
					<Formatted text={benefit.heading} />
				</h3>
				<p
					class="!text-xs/[1.5] md:!text-[0.875rem] lg:!text-base text-black !m-0 font-medium text-ellipsis overflow-hidden"
				>
					<Formatted text={benefit.description} />
				</p>
			</div>
		</article>
	{/each}
</div>
